import inter from 'intersection-observer';
import Vue from 'vue';
import app from './app';
// import app from './components/engage/scene';
import VueAnalytics from 'vue-analytics';
//import WebRTC from 'vue-webrtc';
// import VuePeerJS from 'vue-peerjs';
// import Peer from 'peerjs';
//import Storage from 'vue-ls';
// import VuexPersistence from 'vuex-persist';
import VueYouTubeEmbed from 'vue-youtube-embed';
import vueMoment from 'vue-moment';
import GlobalEvents from 'vue-global-events';
// import vObserver from './components/v-observer';
import vueIntersect from '@arnellebalane/vue-intersect';
import VueObserveVisibility from 'vue-observe-visibility';
import VueLazyload from 'vue-lazyload';
import vueClipboard from 'vue-clipboard2';
import notifications from 'vue-notification';
import Donut from 'vue-css-donut-chart';
import 'vue-css-donut-chart/dist/vcdonut.css';
import vueResizeText from 'vue-resize-text';
import VueMasonry from 'vue-masonry-css';
// import del from './components/topo-components/delete';
// import zoomer from './components/cheatsheet/zoomer';
import storePromise from './store';
window.inter = inter;
Vue.hub = Vue.hub || new Vue();
Vue.prototype.hub = Vue.prototype.hub || Vue.hub;
init();
async function init() {
  //const storePromise = await import('./store');
  const store = await storePromise;
  console.log('store', store);
  vueClipboard.config.autoSetContainer = true;
  Vue.use(vueClipboard);
  Vue.use(notifications);
  Vue.use(VueLazyload, {
    observer: true
  });
  Vue.use(Donut);
  Vue.use(vueResizeText);
  Vue.use(VueMasonry);
  (() => {
    let id = 'UA-147265144-1';
    const { href } = location;
    if (/qa\./.test(href)) {
      id = 'G-4S9KBPNTJV';
    } else if (/trial\./.test(href)) {
      id = 'G-HKPSP4BZLW';
    }
    Vue.use(VueAnalytics, {
      id,
      autoTracking: {
        exception: true,
        exceptionLogs: true
        //screenview: true
      },
      debug: {
        enabled: false,
        sendHitTask: /weave/.test(location.href)
      }
    });
  })();
  window.vaEvent = event;
  window.vga = Vue.$ga;
  Vue.use(VueYouTubeEmbed);
  Vue.use(vueMoment);
  Vue.use(vueIntersect);
  Vue.use(VueObserveVisibility);
  //Vue.use(WebRTC);
  // Vue.use(VuePeerJS, new Peer({}));
  Vue.component('GlobalEvents', GlobalEvents);
  // Vue.component('delete', del);
  // Vue.component('zoomer', zoomer);
  // Vue.directive('observer', vObserver);
  /*Vue.use(Storage, {
    namespace: 'vwv__', // key prefix
    name: 'ls', // name variable Vue.[ls] or this.[$ls],
    storage: 'local' // storage name session, local, memory
  });*/

  Vue.config.productionTip = false;
  Vue.config.performance = !!/localhost\:80/.exec(location.href);
  //window.nosa = () => store.dispatch('refPubInfoShown', true);
  //window.scrollBy = (...args) => cnsole.log('scrollBy', args);
  const gaMap = getMap();
  const lfMap = getLFMap();
  const { event, page } = Vue.$ga;
  const gaMethods = { event, page };
  const actionLogger = ({ type, payload }) => {
    const loading = store.getters.lazyLevel > 60 || /^load/.test(type);
    if (!loading /* && mapped*/) {
      const mapped = gaMap[type];
      //const ignore = mapped?.[3];
      //console.log('ga', type, mapped, payload, 'ignore:', ignore && ignore(payload));
      if (mapped) {
        const [method, eventCategory, eventAction] = mapped;
        const gaMethod = gaMethods[method];
        if (gaMethod) {
          const encode = mapped[4] || (v => v);
          console.log('ga', eventCategory, eventAction, type, encode(payload));
          gaMethod(eventCategory, eventAction, type, encode(payload));
        } else {
          console.log('no method', method);
        }
      }
      const lfMapped = lfMap[type];
      if (lfMapped) {
        Vue.$localforage.setItem(type, payload);
      }
    }
  };
  store.watch(
    (state, { engageRoboReportUrl }) => ({ engageRoboReportUrl }),
    (change) => {
      console.log('main ga store watcher', change);
      const [key] = Object.keys(change);
      actionLogger({ type: key, payload: change[key] });
    }
  );
  store.subscribeAction(actionLogger);
  const { dispatch, getters } = store || {};
  init();
  async function init() {
    //await dispatch('addLoader');
    try {
      const cs = cheatsheet();
      console.log('cs', cs);
      const f = folder();
      const eg = engage();
      window.f_f_f = f;
      const rw = robo();
      const wl = watchList();
      dispatch('refPubInfoNudge', { top: 0, left: 0});
      const loadPage = id => {
        const p = pg();
        if (p) {
          setTimeout(async () => {
            console.log('page', p);
            await dispatch('lazyLevel', 45);
            setTimeout(async () => {
              await dispatch('pdf', `https://content.weave.ai/documents/${ id }-${ p }.pdf`);
              // window.scrollBy({
              //   behavior: 'smooth',
              //   top: document.querySelector('.analysis .viewer').getBoundingClientRect().top - 50
              // });
              //dispatch('removeLoader');
            }, 2000);
            // setTimeout(async () => {
            //   await dispatch('pdf', `https://content.weave.ai/documents/${ id }-${ p }.pdf`);
            //   window.scrollBy({
            //     behavior: 'smooth',
            //     top: document.querySelector('.analysis .viewer').getBoundingClientRect().top - 50
            //   });
            //   //dispatch('removeLoader');
            // }, 8000);
          }, 100);
        }
      };
      await dispatch('selectedThemes', {});
      if (cs) {
        console.log('cheat sheet mode', cs);
        await dispatch('cheatsheetLP', cs);
        dispatch('removeLoader');
      } else if (wl) {
        console.log('wl');
        await dispatch('watchlistShown', true);
        await dispatch('loadWatchlist', wl);
        addPopstate();
        // console.log('adding popstate handler');
        // window.onpopstate = async (event) => {
        //   console.log(`location: ${ document.location }, state: ${ Object.keys(event) }`);
        //   if (getters.backToRobo) {
        //     dispatch('roboWeaveShown', true);
        //     dispatch('backToRobo', false);
        //     dispatch('insightsShown', false);
        //     console.log('backToRobo was true');
        //   }
        // };
      } else if (rw) {
        await dispatch('loadRobo', rw);
        /*const [first] = Object.keys(getters.folderList);
        if (first) {
          await dispatch('loadDoco', first);
        }*/
        addPopstate();
      } else if (eg) {
        dispatch('addLoader', 'main engage');
        await dispatch('loadEngage', eg);
      } else if (f) {
        dispatch('addLoader', { delay: 0.125, from: 'main folder' });
        await dispatch('loadFolder', f);
        const [first] = Object.keys(getters.folderList);
        const d = did();
        if (d) {
          await dispatch('focusMode', true);
        }
        if (d || first) {
          await dispatch('loadDoco', d || first);
          if (d) {
            await dispatch('folderDoco', d);
            loadPage(d);
          } else {
            //dispatch('removeLoader');
          }
        } else {
          //dispatch('removeLoader');
        }
      } else {
        const rl = readingList();
        console.log('rl', rl);
        const index = readingListIndex();
        const current = rl && rl[index];
        const id = current || docId();
        console.log('current', current);
        if (current) {
          await dispatch('readingList', rl);
          await dispatch('readingListIndex', index);
        }
        await dispatch('loadDoco', id);
        loadPage(id);
        //await store.dispatch('tickers');
      }
    } catch (ex) {
      // todo: 404 with search open
      console.log('error fetching doco', ex);
    } finally {
      setTimeout(() => dispatch('smallDocos'), 4000);
    }
    new Vue({
      store,
      render: h => h(app)
    }).$mount('#app');
    function addPopstate() {
      console.log('adding popstate handler');
      window.addEventListener('popstate', async (event) => {
        console.log(`location: ${ document.location }, state: ${ Object.keys(event) }`);
        if (getters.backToRobo) {
          dispatch('roboWeaveShown', true);
          dispatch('backToRobo', false);
          dispatch('insightsShown', false);
          console.log('backToRobo was true');
          event.preventDefault();
        }
      });
    }
    function docId() {
      return (window.location.search || 'z_OKfg5SMEuPjP5PnUJ0sQ').replace(/^\?/, '').replace(/\;.*$/, '');
    }
    /*function hasReadingList() {
      return /[\?\;\&]rl\=/.test(window.location.search);
    }*/
    function cheatsheet() {
      return (/[\?\;\&](c[A-Z]{3}\-\d{3})/.exec(window.location.search || '') || [])[1] || '';
      //return ['jVmKoOyJ3EeCW92zrNIPgg', 'ZTzkVfPDcEeli9Tbw7n0JQ', 'nvAsSDzhnEy1NYHm_4mKPg', 'uA8U-icPHkapALFhDgokOQ', 'JeWiEbCtjkuZXJzVxeYVbQ'];
    }
    function engage() {
      return (/[\?\;\&]eg\=([^\;]+)/.exec(window.location.search || '') || [])[1] || '';
    }
    function folder() {
      return (/[\?\;\&]f\=([^\;]+)/.exec(window.location.search || '') || [])[1] || '';
    }
    function did() {
      return (/[\?\;\&]did\=([^\;]+)/.exec(window.location.search || '') || [])[1] || '';
    }
    function pg() {
      return (/[\?\;\&]pg\=([^\;]+)/.exec(window.location.search || '') || [])[1] || '';
    }
    function robo() {
      return (/[\?\;\&]rw\=(.+)/.exec(window.location.search || '') || [])[1] || '';
    }
    function watchList() {
      return (/[\?\;\&]wl\=([^\;\&]+)/.exec(window.location.search || '') || [])[1] || '';
    }
    function readingList() {
      return ((/[\?\;\&]rl\=\[([^\]]+)\]/.exec(window.location.search || '') || [])[1] || '').split(',');
      //return ['jVmKoOyJ3EeCW92zrNIPgg', 'ZTzkVfPDcEeli9Tbw7n0JQ', 'nvAsSDzhnEy1NYHm_4mKPg', 'uA8U-icPHkapALFhDgokOQ', 'JeWiEbCtjkuZXJzVxeYVbQ'];
    }
    function readingListIndex() {
      return ((/[\?\;\&]rli\=(\d+)/.exec(window.location.search || '') || [])[1] || 0) * 1;
    }
  }
  function getMap() {
    const ev = ['event', 'view'];
    const ec = ['event', 'main', 'click'];
    const iec = ['event', 'insights', 'click'];
    const eq = ['event', 'main', 'quantile'];
    const ieq = ['event', 'insights', 'quantile'];
    return {
      // todo: debug these load ga's
      loadDoco: ev,
      loadEngage: ev,
      toggleTag: ec,
      facetsCollapsed: ec,
      'insightsNS/facetsCollapsed': iec,
      selectDoc: [...ec, a => 'select' in a, a => a.pgn],
      selectedToggler: ec,
      sentiment: eq,
      interestingness: eq,
      visuality: eq,
      age: eq,
      duration: eq,
      selectedCategories: ec,
      selectedSectors: ec,
      'insightsNS/volume': ieq,
      'insightsNS/sentiment': ieq,
      pdf: iec,
      cloud: ec,
      currentVideo: ec,
      ...engageMap()
    };
    function engageMap() {
      return {
        engageViewMode: ec,
        engagePlaying: ec,
        engageReportCardShown: ec,
        engageSelectedSection: ec,
        //engageRoboReport: ec,
        engageSelectedDocuments: ec,
        engageSelectedPublishers: ec,
        engageOnlyLastQuarter: ec,
        engageMaxAge: ec,
        engageSelectedThemes: ec,
        engageKeywords: ec,
        engageLinksShown: ec,
        styleFilter: ec,
        dividendOnly: ec,
        engageNewOnly: ec,
        engageSelectedRegions: ec,
        engageSelectedSectors: ec,
        engagePub: ec,
        engagePubContext: ec,
        engageNotificationsShown: ec,
        engageTheme: ec,
        engageVideosOnly: ec,
        engageTweetsOnly: ec,
        nextVideo: ec,
        prevVideo: ec,
        // tracking actions
        engageNotificationClicked: ec,
        engageExitClicked: ec,
        videoPauseEvent: ec,
        toggleFullScreenEvent: ec,
        insightClicked: ec,
        itemCopied: ec,
        videoClicked: ec,
        // track getters
        engageRoboReportUrl: ec
      };
    }
  }
  function getLFMap() {
    return {
      q: true,
      //toggleTag: true,
      andOr: true,
      facetsCollapsed: true,
      'insightsNS/facetsCollapsed': true,
      //selectDoc: true,
      selectedToggler: true,
      sentiment: true,
      interestingness: true,
      visuality: true,
      age: true,
      duration: true,
      selectedCategories: true,
      selectedSectors: true,
      sharing: true,
      editing: true,
      zoomLevel: true,
      compressedInsights: true,
      'insightsNS/q': true,
      'insightsNS/volume': true,
      'insightsNS/sentiment': true,
      'insightsNS/andOr': true,
      'insightsNS/hasFactoids': true,
      'insightsNS/hasDirectives': true,
      plainInsights: true,
      newTheme: true
      //pdf: true,
      //pdfView: true
      // cloud: true
    };
  }
}
